import { Edit, required, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar } from 'react-admin';
import ContextTitle from '../../Components/ContextTitle';
import { partnerStatusChoices } from '../../lib/partners';

const PartnerEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show" title={<ContextTitle context="name" />}>
    <SimpleForm
      toolbar={
        <Toolbar>
          <SaveButton />
        </Toolbar>
      }
    >
      <TextInput disabled source="uuid" label="UUID" />
      <TextInput source="name" label="Name" validate={required()} />
      <SelectInput source="status" label="Status" choices={partnerStatusChoices} validate={required()} />
    </SimpleForm>
  </Edit>
);

export default PartnerEdit;
